// extracted by mini-css-extract-plugin
module.exports = {"editor":"TimeDurationPicker_editor__qEybI","label":"TimeDurationPicker_label__1ky0K"};